<template>
  <button
    :disabled="loading"
    type="button"
    @click="$emit('click')"
    :class="[
      'customize-button',
      `customize-button-${size}`,
      `customize-button-${size}-${type}`,
    ]"
    :style="btnStyle"
  >
    <span v-if="loading">
      <i class="el-icon-loading" />
      loading
    </span>
    <span v-else>
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'customize-button',
  props: {
    size: {
      type: String,
      default: 'medium',
    },
    type: {
      type: String,
      default: 'default',
    },
    btnStyle: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.customize-button {
  border: none;
  border-radius: 27px;
  cursor: pointer;
  box-sizing: border-box;
}

// medium
.customize-button-medium {
  height: 32px;
  padding: 8px 16px;

  span {
    font-size: 14px;
  }
}

.customize-button-medium-default {
  background-color: #fff;
  box-shadow: 0 4px 16px 0 rgba(179, 192, 231, 0.32);
  color: #6a74a5;

  &:hover {
    color: #71a0fe;
    box-shadow: 0 4px 16px 0 rgba(179, 192, 231, 0.32);
  }
}

.customize-button-medium-primary {
  background-image: linear-gradient(46deg, #fe7301 0%, #e41e20 100%);
  box-shadow: 0 4px 16px 0 rgba(158, 2, 32, 0.1);
  color: #fff;

  &:hover {
    background: #71a0fe;
    box-shadow: 0 4px 16px 0 #b3c0e7;
  }
}

.customize-button-medium-disabled {
  background-color: #dae0f2;
  color: #858ebd;
  cursor: no-drop;
}

// large
.customize-button-large {
  height: 54px;
  padding: 15px 32px;

  span {
    font-size: 18px;
  }
}

.customize-button-large-default {
  background-color: #fff;
  box-shadow: 0 4px 16px 0 rgba(179, 192, 231, 0.32);
  color: #4458fe;

  &:hover {
    color: #71a0fe;
    box-shadow: 0 4px 16px 0 rgba(179, 192, 231, 0.32);
  }
}

.customize-button-large-primary {
  background-image: linear-gradient(46deg, #fe7301 0%, #e41e20 100%);
  box-shadow: 0 4px 16px 0 rgba(158, 2, 32, 0.1);
  color: #fff;

  &:hover {
    background: #71a0fe;
    box-shadow: 0 4px 16px 0 #b3c0e7;
  }
}

.customize-button-large-disabled {
  background-color: #dae0f2;
  color: #858ebd;
  cursor: no-drop;
}
</style>
